module.exports = __webpack_public_path__ + "img/accumulated_seconds.33a0d036.svg";